<template>
    <div>
        <van-sticky>
            <van-dropdown-menu>
                <van-dropdown-item @change="changeDropdown" v-model="dropdownFilter.orderBy.value"
                                   :options="dropdownFilter.orderBy.option"/>
                <van-dropdown-item @change="changeDropdown" v-model="dropdownFilter.industry.value"
                                   :options="dropdownFilter.industry.option"/>
            </van-dropdown-menu>
        </van-sticky>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="get_data"
            >
                <div v-for="item in ExternalUserFollowInfo_BuyStau.StdQuery" :key="item" @click="openDetail(item)">
                    <van-cell is-link
                              :title="item.ExternalUserId">
                        <template #title>
                            <div class="title">
                                <van-image
                                        round
                                        width="20px"
                                        height="20px"
                                        fit="cover"
                                        :src="item.Avatar"
                                />
                                {{ item.Name }}
                            </div>

                        </template>
                        <template>
                            <div>
                                {{ item.StatusMemo }}-{{ item.CreateDate }}
                            </div>
                        </template>
                    </van-cell>
                    <div class="status_memo">
                        <div style="display: flex;align-items: center;padding-bottom: 6px">
                            <div style="display:flex;flex: 1">
                                <van-image v-if="item.CPAvatar"
                                        round
                                        width="20px"
                                        height="20px"
                                        fit="cover"
                                        :src="item.CPAvatar"
                                />
                                <div style="padding-left: 12px">{{ item.CPName }}</div>
                            </div>
                            <div style="display: flex;align-items: center">
                                <div v-if="item.ExpectAmount">预计成交:{{ item.ExpectAmount }}-
                                </div>
                                <div v-if="item.IndustryDesc">
                                    {{ item.IndustryDesc }}-
                                </div>
                                <div v-else>未填写行业-</div>
                                {{ item.StatusMemo }}
                            </div>
                        </div>
                        <div>
                            {{ item.LastMemo }}
                            <div class="font12" style="padding-top: 12px">{{ item.LastMemoDate }}</div>
                        </div>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            loading: false,
            finished: false,
            Status: 0,
            ExternalUserFollowInfo_BuyStau: {
                StdQuery: []
            },
            OrderBy: 0,
            refreshing: false,
            start: 0,
            length: 10,
            value1: 0,
            value2: 0,

            option2: [
                {text: '全部行业', value: 0},
                {text: '添加时间远到近', value: 1},
                {text: '添加时间近到远', value: 2},
                {text: '跟进时间远到近', value: 3},
                {text: '跟进时间近到远', value: 4},
            ],
            dropdownFilter: {
                orderBy: {
                    value: 0,
                    option: [
                        {text: '默认排序', value: 0},
                        {text: '添加时间远到近', value: 1},
                        {text: '添加时间近到远', value: 2},
                        {text: '跟进时间远到近', value: 3},
                        {text: '跟进时间近到远', value: 4},
                    ],
                },
                industry: {
                    value: '0',
                    option: [
                        {text: '全部行业', value: '0'},
                    ],
                }

            }
        }
    },
    created() {
        const route = this.$route;
        this.Status = route.query.Status
        this.getWXIndustry()
    },
    methods: {
        changeDropdown(value) {
            this.onRefresh()
        },
        openDetail(item) {
            this.$router.push({
                path: "/work/detail",
                query: {
                    ExternalUserId: item.ExternalUserId
                }
            });
        },
        async get_data() {
            let _data = await this.$frame.getStdQueryData("FunnelAll_ByStatus", {
                Status: this.Status,
                start: this.start,
                length: this.length,
                OrderBy: this.dropdownFilter.orderBy.value,
                Industry: this.dropdownFilter.industry.value

            })
            this.ExternalUserFollowInfo_BuyStau.StdQuery = this.ExternalUserFollowInfo_BuyStau.StdQuery.concat(_data.StdQuery)
            if (_data.StdQuery.length == 10) {
                this.start += 10
            } else if (_data.StdQuery.length < 10) {
                this.finished = true
            }
            if (this.refreshing) {
                this.refreshing = false;
            }
            // 加载状态结束
            this.loading = false;
        },
        onRefresh() {
            this.ExternalUserFollowInfo_BuyStau.StdQuery = []
            // 清空列表数据
            this.start = 0
            this.length = 10

            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.get_data();
        },
        async getWXIndustry() {
            let _data = await this.$frame.getStdQueryData("WXIndustry")
            this.dropdownFilter.industry.option = [{text: '全部行业', value: '0'}]
            for (let i = 0; i < _data.StdQuery.length; i++) {
                this.dropdownFilter.industry.option.push({
                    text: _data.StdQuery[i].IndustryDesc,
                    value: _data.StdQuery[i].IndustryNO
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  ::v-deep {
    .van-image {
      margin-right: 12px;
    }
  }
}

.status_memo {
  background-color: #fff;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: $base-box-shadow;
}
</style>
